
// en.js
export default {
  '语言切换': 'Language switch',
  "手机号登录":"Mobile number login",
  "邮箱号登录":"Email login",
  "请输入手机号":"Please enter your phone number",
  "请输入邮箱号":"Please enter your email address",
  "请输入密码":"Please enter the password",
  "验证码登录":"Verification code login",
  "登录":"login",
  "忘记密码":"Forgot password",
  "注册":"register",
  "已阅读并同意":"Read and agreed",
  "用户注册协议":"User registration agreement",
  "与":"and",
  "隐私政策":"Privacy Policy",
  "密码登录":"Password login",
  "请输入验证码":"Please enter the verification code",
  "获取验证码":"Get verification code",
  "秒后重新获取":"Retrieve again in seconds",
  "手机号注册":"Mobile number registration",
  "邮箱号注册":"Email registration",
  "确定":"confirm",
  "手机号找回":"Recover phone number",
  "邮箱号找回":"Email account recovery",
  "专业外卖平台":"Professional food delivery platform",
  "退出":"exit",
  "确定要退出么？":"Are you sure you want to exit？",
  "客服二维码":"Customer Service QR Code",
  "点单界面":"Order interface",
  "简体中文":"Simplified Chinese",
  "英文":"EN",
  "切换语言":"Switch language",
  "返回":"return",
  "两菜点餐":'Order two dishes',
  "三菜点餐":'Order three dishes',
  "选择配送地址":"Select delivery address",
  "新增地址":"Add new address",
  "暂无可用地址":"No available address at the moment",
  "温馨提示":"Kind Reminder",
  "选中的日期都需要选择菜品哦":"All selected dates require the selection of dishes",
  "知道了":"Understood",
  "饭票不足，请前往充值":"Insufficient meal tickets, please go and recharge",
  "稍后再说":"Later",
  "立即充值":"Top up now",
  "个人中心":"Personal Center",
  "预约":'appointment',
  "历史订单":"Historical Orders",
  "收货地址":"Receiving address",
  "联系客服":"Contact Customer Service",
  "设置":"Settings",
  "绑定企业":"bind the enterprise",
  "饭票":"meal ticket",
  "详情":"Details",
  "充值":"top-up",
  "我的预约":"My appointment",
  "您目前没有即将送餐的订单":"You currently do not have any upcoming delivery orders",
  "前往预定":"Proceed to book",
  "审核中":"Under review",
  "绑定企业后，不可修改，请谨慎操作":"After binding the enterprise, it cannot be modified. Please proceed with caution",
  "请输入企业名称":"Please enter the company name",
  "搜索":"search",
  "绑定":"bind",
  "请输入企业名称":"Please enter the company name",
  "取消":"Cancel",
  "确认":"confirm",
  "确定绑定":"Confirm binding",
  "吗":"ma",
  "提交绑定后，将不可修改请谨慎操作":"After submitting the binding, it will not be modifiable. Please proceed with caution",
  "我的饭票":"my meal ticket",
  "饭票明细":"Meal Ticket Details",
  "个人饭票":"Personal meal ticket",
  "张":"Zhang",
  "2菜饭票":"Order two dishes",
  "3菜饭票":"Order three dishes",
  "朋友饭票":"Friend meal ticket",
  "个人":"individual",
  "好友":"friend",
  "三菜":"Three dishes",
  "二菜":"Two dishes",
  "饭票充值":"Recharge meal tickets",
  "套餐购买，默认自动续费。在饭票低于5张时候，自动充值。可在个人中心设置里面进行取消":"Package purchase, default automatic renewal. Automatically recharge when the number of meal tickets is less than 5. You can cancel it in the personal center settings",
  "立即充值":"Top up now",
  "查看充值订单":"View recharge orders",
  "支付金额":"Payment amount",
  "微信支付":"WeChat Pay",
  "支付宝支付":"Alipay payment",
  "微信扫码支付":"WeChat QR code payment",
  "支付宝扫码支付":"Alipay code scanning payment",
  "支付成功":"Payment successful",
  "返回个人中心":"Return to Personal Center",
  "充值订单":"Top-up order",
  "手动充值":"Manual recharge",
  "自动划扣":"Automatic deduction",
  "预约":"appointment",
  "配送中":"Delivery in progress",
  "暂无预约":"No appointments available at the moment",
  "预订更多":"Book more",
  "份":"copy",
  "已完成":"Completed",
  "已取消":"Canceled",
  "历史订单":"Historical Orders",
  "订单详情":"Order Details",
  "配送日期":"Delivery date",
  "待配送":"Pending delivery",
  "订单信息":"Order Information",
  "订单编号":"Order Number",
  "下单时间":"Order time",
  "取消订单":"Cancel order",
  "预约套餐":"Booking Package",
  "两菜饭票":"Order two dishes",
  "三菜饭票":"Order three dishes",
  "下单成功":"Order successfully placed",
  "查看预约":"View appointments",
  "返回首页":"Return to Home",
  "确定要取消订单吗？取消后，订单饭票将退回":"Are you sure you want to cancel the order? After cancellation, the meal ticket for the order will be returned",
  "稍后再说":"Later",
  "确认取消":"Confirm Cancel",
  "已退回":"Returned",
  "收货人":"Consignee",
  "联系方式":"Contact Information",
  "地址":"address",
  "操作":"operation",
  "编辑":"edit",
  "删除":"delete",
  "默认地址":"Default address",
  "设置默认地址":"Set default address",
  "添加地址":"Add address",
  "选择地址":"Select address",
  "请选择":"Please select",
  "联系人":"Contact",
  "请输入收货人":"Please enter the recipient",
  "先生":"sir",
  "女士":"lady",
  "联系电话":"Contact number",
  "详细地址":"detailed address",
  "请输入详细地址，以便师傅配送":"Please enter a detailed address for the master to deliver",
  "提示":"prompt",
  "确定要删除该地址吗":"Are you sure you want to delete this address",
  "我的消息":"My message",
  "平台公告":"Platform Announcement",
  "订单通知":"Order Notification",
  "已读":"Read",
  "未读":"Unread",
  "客服工作时间":"Customer service working hours",
  "修改登录密码":"Change login password",
  "修改绑定邮箱号":"Modify bound email address",
  "修改绑定手机号":"Modify bound phone number",
  "当饭票低于":"When the meal ticket is lower than",
  "张的时候，自动充值":"Automatically recharge when using Zhang",
  "旧密码验证":"Old password verification",
  "手机号验证":"Mobile number verification",
  "邮箱号验证":"Email verification",
  "旧密码":"Old password",
  "请输入旧密码":"Please enter old password",
  "新密码":"new password",
  "请输入新密码":"Please enter a new password",
  "确认新密码":"Confirm new password",
  "请再次输入新密码":"Please enter the new password again",
  "我们要对您绑定的手机号进行验证":"We need to verify the phone number you have bound",
  "验证码":"CAPTCHA",
  "请输入验证码":"Please enter the verification code",
  "我们要对您绑定的邮箱号进行验证":"We need to verify the email address you have bound",
  "新的手机号":"New phone number",
  "新的邮箱号":"New email address",
  "请勾选协议":"Please check the agreement",
  "请选择地址":"Please select the address",
  "选择":"choice",
  "套餐":"combo",
  "请输入详细地址":"Please enter detailed address",
  "添加成功":"Added successfully",
  "编辑成功":"Edit successful",
  "确定要删除该地址吗？":"Are you sure you want to delete this address?",
  "待支付":"Pending Payment",
  "拼命加载中":"Loading desperately",
  "两次输入密码不一致":"The password entered twice is inconsistent",
  "门牌号":"House number ",
  "请输入门牌号":"Please enter the house number",
  "街道名称":"Street Name",
  "请输入街道名称":"Please enter street name",
  "州邮编":"State Postal Code",
  "请输入州邮编":"Please enter state zip code",
  "额外赠送":"extra gift",
  "张好友饭票":"Zhang's friend's meal ticket",
  "请选择菜品":"Please select dishes",
  "个人主页":"Personal Homepage",
  "备注":"remark",
  "请输入备注":"Please enter remarks",
};